<div
  class="more-button {{ menuStyle() }}"
  [ngClass]="{ 'active-button': menuOpened() }"
  cdkOverlayOrigin
  #overflowItemsTrigger="cdkOverlayOrigin"
  (click)="menuOpened.set(true)"
>
  <span class="twc-typography-body-2-medium twc-color-secondary-typeface"
    >More</span
  >

  <twc-badge [count]="overflowItems()?.length" color="secondary" />

  <mat-icon svgIcon="twc:down" class="twc-icon-stroke-secondary-typeface" />
</div>

<ng-template
  cdkConnectedOverlay
  cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
  [cdkConnectedOverlayOrigin]="overflowItemsTrigger"
  [cdkConnectedOverlayOpen]="menuOpened()"
  [cdkConnectedOverlayHasBackdrop]="true"
  [cdkConnectedOverlayOffsetY]="6"
  (backdropClick)="menuOpened.set(false)"
>
  <div class="overlay-pane min-width-auto">
    @for (option of overflowItems(); track option.title) {
      <mat-option
        class="twc-typography-body-1 twc-color-primary-typeface"
        (click)="onOptionClick(option)"
      >
        {{ option.title }}
      </mat-option>
    }
  </div>
</ng-template>
